export default __webpack_public_path__ + "feature2ac99c8.png";